// Re-exports from unified color system
import { PRIMITIVE_COLORS, SEMANTIC_COLORS } from '../residentColors';

export const LINKED_ACCOUNTS_COLORS = {
  background: SEMANTIC_COLORS.background.primary,
  cardBackground: SEMANTIC_COLORS.background.secondary,
  avatarBackground: PRIMITIVE_COLORS.white10,
  navHeaderBackground: PRIMITIVE_COLORS.resioBlue,
  navHeaderInvitationsBackground: PRIMITIVE_COLORS.resioPurple,
  innerFrameBackground: SEMANTIC_COLORS.background.primary,
  textPrimary: SEMANTIC_COLORS.text.primary,
  textSecondary: PRIMITIVE_COLORS.gray300,
  textMuted: PRIMITIVE_COLORS.gray400,
  accentPink: PRIMITIVE_COLORS.resioPink,
  accentBlue: PRIMITIVE_COLORS.resioBlue,
  accentBlueBorder: PRIMITIVE_COLORS.resioBlueBorder,
  accentPurple: PRIMITIVE_COLORS.resioPurple,
  divider: PRIMITIVE_COLORS.gray700,
  iconPrimary: SEMANTIC_COLORS.icon.primary,
  iconSecondary: SEMANTIC_COLORS.icon.secondary,
  successGreen: '#5CBC5D',
  successText: SEMANTIC_COLORS.text.inverse,
  buttonDisabled: PRIMITIVE_COLORS.gray600,
  warningOrange: PRIMITIVE_COLORS.warningOrange,
} as const;

export type LinkedAccountsColor = keyof typeof LINKED_ACCOUNTS_COLORS;
